import React from "react";
import { useSelector } from "react-redux";

import BasicInfo from "./BasicInfo";
import CandidateProfile from "./CandidateProfile";

/**
 * Render the left section of the candidate detail view.
 *
 * @return {JSX.Element} The JSX for the left section of the candidate detail view.
 */
const CandidateDetailLeft = () => {
  const { showProfile } = useSelector((state) => state.clientCandidateDetail);
  return (
    <div
      className={`CandidateDetailLeft_Wrapper candidates_left_box_shadow order-2 overflow-hidden bg-white lg:order-1 ${showProfile ? "w-full md:w-[350px] md:min-w-[350px]" : "w-[0px]"} `}
    >
      <div className="grid">
        <BasicInfo />
        <CandidateProfile />
      </div>
    </div>
  );
};

export default CandidateDetailLeft;
